/** @jsxImportSource @emotion/react */

import { CalendarOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Calendar, listCalendar } from "contants/list-calendar";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { theme } from "styles/theme";

import DatePickerCustom from "../DatePickerCustom";
import { TimeLineStyle } from "./index.style";

type State = {
  currentPage?: number;
  idDate: string;
  visible: boolean;
  dataItem: any;

  startDate: Dayjs | null;
  endDate: Dayjs | null;
};

interface Props {
  handleOnChangeDate: (item: Calendar) => void;
  idDate: string;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  // setState: React.Dispatch<React.SetStateAction<State>>;
  setState: any;
  isDisable: boolean;
  getDataWager: () => void;
  isLoading: boolean;
}

export const TimeLineCustom: React.FC<Props> = ({
  handleOnChangeDate,
  idDate,
  startDate,
  setState,
  endDate,
  isDisable,
  getDataWager,
  isLoading,
}) => {
  const { t } = useTranslation(["transaction", "Apply", "placeholder"]);

  const _setState = setState as React.Dispatch<React.SetStateAction<State>>;
  return (
    <>
      <div css={TimeLineStyle.blockCalendar}>
        {listCalendar.map((itemCalendar, index) => {
          return (
            <div
              key={`key-${index}-buton-calendar`}
              onClick={() => {
                handleOnChangeDate(itemCalendar);
              }}
              css={TimeLineStyle.buttonCalendar(idDate === itemCalendar.id)}
            >
              {t(itemCalendar.value)}
            </div>
          );
        })}
      </div>
      <div css={TimeLineStyle.fromGroupContainer}>
        <div css={TimeLineStyle.formGroup}>
          <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>
            {t("transaction:StartDate")}{" "}
            <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>*</span>
          </span>
          <DatePickerCustom
            value={startDate}
            format={"DD/MM/YYYY"}
            placeholder={t("placeholder:SelectDate")}
            onChange={(val) => {
              if (val && val.isValid()) {
                // Kiểm tra nếu val hợp lệ
                _setState((prev) => ({
                  ...prev,
                  startDate: dayjs(val),
                }));
              } else {
                _setState((prev) => ({
                  ...prev,
                  startDate: null,
                }));
              }
            }}
            disabledDate={(current) => {
              return current > dayjs().endOf("day");
            }}
            suffixIcon={<CalendarOutlined css={TimeLineStyle.iconCalendar} />}
          />
        </div>
        <div css={TimeLineStyle.fromDash}>
          <span>To</span>
          <span>{t("To")}</span>
        </div>

        <div css={TimeLineStyle.formGroup}>
          <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>
            {t("EndDate")}{" "}
            <span css={TimeLineStyle.spanDate(theme.colors.darkGreen)}>*</span>
          </span>
          <DatePickerCustom
            value={endDate}
            placeholder={t("placeholder:SelectDate")}
            format={"DD/MM/YYYY"}
            disabledDate={(current) => {
              return current > dayjs().endOf("day");
            }}
            onChange={(val) => {
              if (val && val.isValid()) {
                // Kiểm tra nếu val hợp lệ
                _setState((prev) => ({
                  ...prev,
                  endDate: dayjs(val),
                }));
              } else {
                _setState((prev) => ({
                  ...prev,
                  endDate: null,
                }));
              }
            }}
            suffixIcon={<CalendarOutlined css={TimeLineStyle.iconCalendar} />}
          />
        </div>
        <div css={TimeLineStyle.formSubmit}>
          <span css={TimeLineStyle.blockEmpty}>empty</span>
          <Button
            type="primary"
            size="large"
            css={TimeLineStyle.btnSubmit}
            htmlType="submit"
            disabled={!isDisable}
            onClick={getDataWager}
            loading={isLoading}
          >
            {t("button:Apply")}
          </Button>
        </div>
      </div>
    </>
  );
};
